import { useNavigate } from 'react-router-dom'
import { useUnit } from 'effector-react'
import { Breadcrumb, Card, Typography } from 'antd'
import { path } from 'src/libs'
import { FormWebPage } from 'src/pages/ib/adMaterials/webSitePages/components'
import { createWebSiteFx } from 'src/pages/ib/adMaterials/webSitePages/model'
import { WebSitePayload } from 'src/pages/ib/adMaterials/webSitePages/types'

export const CreateWebSitePage = () => {
  const navigate = useNavigate()
  const { Title, Text } = Typography

  const handleSubmit = async (values: WebSitePayload) => {
    try {
      await createWebSiteFx({ body: { ...values } })
      navigate(path.ib.ad.website_pages.entry())
    } catch (error) {
      console.error(error)
    }
  }
  const loadingCreate = useUnit(createWebSiteFx.pending)

  return (
    <Card>
      <Breadcrumb
        items={[
          {
            title: (
              <Text
                style={{
                  cursor: 'pointer',
                  color: 'var(--color-primary)',
                }}
                onClick={() => navigate(path.ib.ad.website_pages.entry())}
              >
                WebSite Pages
              </Text>
            ),
          },
          {
            title: <Text type="secondary">Create WebSite Page Link</Text>,
          },
        ]}
        style={{ marginBottom: 24 }}
      />
      <Title level={4}>Create WebSite Page Link</Title>
      <FormWebPage
        initialValues={{ isVisible: true }}
        onSubmit={handleSubmit}
        loading={loadingCreate}
      />
    </Card>
  )
}
